import { getGuid } from 'owa-guid';
import { makePostRequest } from 'owa-ows-gateway';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import * as trace from 'owa-trace';
import EntityRequest from '../store/schema/EntityRequest';
import ExecuteSuggestionsRequest from '../store/schema/ExecuteSuggestionsRequest';
import { ENTITY_TYPE, SUGGESTIONS_POST_ENDPOINT } from '../utils/searchConstants';
import { default as getMaxEntries } from '../selectors/getMaxEntries';

export default async function substrateSuggestions(
    queryString: string /** Query string for suggestions */,
    cvid: string /** Conversation ID */,
    customHeaders: any /** Any custom headers for request */,
    scenarioName: string /** SubstrateSearchScenario Name - owa.react.filepicker */,
    logicalId: string /** Logical ID */
): Promise<SubstrateSearchSuggestionsResponse> {
    const entityRequest = createEntityRequest(queryString);
    const suggestionJsonRequest = createSuggestionsJsonRequest(
        entityRequest,
        cvid,
        logicalId,
        scenarioName
    );

    return makePostRequest(
        SUGGESTIONS_POST_ENDPOINT + getParams(scenarioName),
        suggestionJsonRequest,
        undefined /*correlationId*/,
        false /*returnFullResponse*/,
        customHeaders,
        true /* throwServiceError */,
        true /* sendPayloadAsBody */,
        /* 3S does not need auth cookies so omitting them will decrease request header size */
        false /* includecredentials */
    )
        .then(resp => {
            return resp;
        })
        .catch(err => {
            trace.trace.info(err);
            return null;
        });
}

function createEntityRequest(queryString: string): EntityRequest {
    let entityRequest: EntityRequest = {
        Query: {
            QueryString: queryString,
        },
        EntityType: ENTITY_TYPE,
        Size: getMaxEntries(),
        From: '0',
    };

    return entityRequest;
}

function createSuggestionsJsonRequest(
    entityRequest: EntityRequest,
    cvid: string,
    logicalId: string,
    scenario: string
): ExecuteSuggestionsRequest {
    return {
        EntityRequests: [entityRequest],
        LogicalId: logicalId,
        Cvid: cvid ? cvid : getGuid(),
        Scenario: {
            Name: scenario,
        },
    };
}

export function getParams(scenario: string): string {
    const params = {
        scenario: scenario,
    };

    return Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&');
}
